import { useMemo } from 'react';
import { buildLeafTrendInsights } from '../utils/buildLeafTrendInsights';
import { buildPaceInsights } from '../utils/buildPaceInsights';

export function useSmartInsights({ allTxns, monthTxns, selMonth, selYear, incomeList, expByGroup, currentBudgets, expenseMap }) {
  return useMemo(() => {
    const leafTrendInsights = buildLeafTrendInsights(allTxns, selMonth, selYear, incomeList);
    const paceInsights = buildPaceInsights(monthTxns, selMonth, selYear, incomeList, expByGroup, currentBudgets, expenseMap);
    return { leafTrendInsights, paceInsights };
  }, [allTxns, monthTxns, selMonth, selYear, incomeList, expByGroup, currentBudgets, expenseMap]);
}
